import React, { Component }        from 'react';
import { withRouter }              from 'react-router';
import { connect as reduxConnect } from 'react-redux';
import { Form }                    from 'react-bootstrap';
import PubSub                      from 'pubsub-js';
import { isLoggedIn }              from '../../../../utils/authService';

class ConnectForm extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      email             : '',
      emailValid        : false,
      emailValidMessage : '',
      name              : '',
      nameValid         : true,
      nameValidMessage  : '',
      studentId         : '',
      anonymousForm     : false
    };
    
    this.handleEmailChange     = this.handleEmailChange.bind(this);
    this.handleNameChange      = this.handleNameChange.bind(this);
    this.handleStudentIdChange = this.handleStudentIdChange.bind(this);
    this.validateArguments     = this.validateArguments.bind(this);
    this.anonymousChat         = this.anonymousChat.bind(this);
    this.subscriber            = this.subscriber.bind(this);
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.token);
  }

  componentDidMount() {  
    this.token = PubSub.subscribe('connect.chat.ui.stateChange', this.subscriber.bind(this));
  }
  
  ///////////////////
  // CHAT METHODS //
  //////////////////
  
  validateArguments(e) {
    var emailValid = this.validateEmail();
    var nameValid  = this.state.name;
    
    const form = e.currentTarget;
    if (form.checkValidity() === false || !emailValid || !nameValid) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    this.setState({
      validated: true,
      emailValid: emailValid,
      nameValid: nameValid
    }); 
    
    return emailValid && nameValid;
  }
  
  validateEmail() {
    const phone  = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
    const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var valid    = (regexp.test(this.state.email) || phone.test(this.state.email));
    return valid;
  }
  
  anonymousChat(e) {
    e.preventDefault();
    if (this.validateArguments(e)) {
      this.setState({
        anonymousForm: false
      }, function() {
        PubSub.publish('feedback.attributes', {
          userId: this.state.email 
        });
        
        PubSub.publish('connect.chat.ui.stateChange', {
          cards     : true,
          email     : this.state.email,
          name      : this.state.name,
          studentId : this.state.studentId
        });
      });
    }
  }
  
  subscriber(msg, data) {
    if (msg === "connect.chat.ui.stateChange" && data.form && !isLoggedIn()) {
      this.setState({
        anonymousForm: true
      });
    }
  }
  
  ////////////////////////
  // KEY/HELPER METHODS //
  ////////////////////////
  
  handleEmailChange(e) {
    this.setState({ 
      email: e.target.value
    }, function() {
      this.setState({
        validated: true,
        emailValid: this.validateEmail()
      });
    });
  }
  
  handleNameChange(e) {
    this.setState({name: e.target.value});
  }
  
  handleStudentIdChange(e) {
    this.setState({studentId: e.target.value});
  }

  render() {  
    return (
      <div>
        { this.state.anonymousForm ?
          <Form id="anonymous-chat-form" noValidate validated={this.state.validated} onSubmit={this.anonymousChat}>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Email address or Phone Number (including area code) *</Form.Label>
              <Form.Control type="text" placeholder="Enter email or phone (including area code)" isValid={this.state.emailValid} value={this.state.email} onChange={this.handleEmailChange} required />
              <span className="text">
                We will use this to send you one-time codes which are used when starting a chat session.
              </span>
              <Form.Control.Feedback type="invalid">
                Please enter a valid phone number or email address
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formBasicName">
              <Form.Label>Name *</Form.Label>
              <Form.Control type="text" placeholder="Name" value={this.state.name} onChange={this.handleNameChange} required />
              <Form.Control.Feedback type="invalid">
                Please enter a valid name
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formStudentId">
              <Form.Label>Student ID</Form.Label>
              <Form.Control type="text" placeholder="Student ID" value={this.state.studentId} onChange={this.handleStudentIdChange} />
              <span className="text">
                Don't worry if you do not have one.
              </span>
            </Form.Group>
            <button type='submit' className="c-btn c-btn--sm" style={{ width: '100%', lineHeight: 0, marginTop: '10px', marginBottom: '10px' }}>
              <span className="c-btn__text">Submit</span>
            </button>
          </Form> 
          :
          <span></span>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default withRouter(reduxConnect(mapStateToProps, mapDispatchToProps)(ConnectForm));
